<template>
	<ModalLayout title="USDT Transfer" :back="onBack">
		<form class="withdrawal section--mini section screen-start" @submit.prevent="onSubmit">
			<div class="withdrawal-form" v-if="!ready">
				<div class="withdrawal-form__address withdrawal-form-address">
					<input type="text" class="withdrawal-form-address__input" required placeholder="Address name" v-model="address">
					<button class="withdrawal-form-address__paste" type="button" @click="pasteAddress">Paste</button>
					<button class="withdrawal-form-address__scan" type="button" @click="scanAddress">
						<Icon name="scan" />
					</button>
				</div>
				<p class="withdrawal-form__hint">The withdrawal process is automatic. Usually, it takes anywhere from 10 minutes to 2-3 hours. However, as a maximum, it can take up to 7 days. The bot needs to close all active trades in order to withdraw the money.</p>
				<label class="withdrawal-form__amount withdrawal-form-amount">
					<input type="text" class="withdrawal-form-amount__input" inputmode="decimal" required v-model="amount" v-auto-size>
					<span class="withdrawal-form-amount__currency">USDT</span>
				</label>
				<p class="withdrawal-form__balance" v-if="false">Current balance: <b>{{ me.balance.toFixed(2) }}</b> <span>USDT</span></p>
				<p class="withdrawal-form__balance">Commission: <b>{{ commission.toFixed(2) }}</b> <span>USDT</span></p>
				<p class="withdrawal-form__comission">Available for withdrawal*: <b>{{ me.balance.toFixed(2) }}</b> <span>USDT</span></p>
				<p class="withdrawal-form__alert">*The commission is charged from the amount. We charge a 10% fee on withdrawals.</p>
			</div>
			<div class="withdrawal-confirmation" v-else>

				<div class="withdrawal-confirmation__row">
					<span class="withdrawal-confirmation__option">Recipient</span>
					<span class="withdrawal-confirmation__value">
						<b>{{ shorty(address, 8) }}</b>
					</span>
				</div>
				<div class="withdrawal-confirmation__row">
					<span class="withdrawal-confirmation__option">Amount</span>
					<span class="withdrawal-confirmation__value">
						<b>{{ amount }}</b> USDT
					</span>
				</div>
				<div class="withdrawal-confirmation__row">
					<span class="withdrawal-confirmation__option">Commission</span>
					<span class="withdrawal-confirmation__value">
						<b>{{ commission }}</b> USDT
					</span>
				</div>
				<p class="withdrawal-confirmation__alert">
					* The commission is charged from the remaining balance. We charge a 10% fee on withdrawals.
				</p>
			</div>
			<transition name="footer-button">
				<Button color="brand" class="withdrawal__button" size="big" v-if="!ready" :disabled="!filled || loading">
					<Loader v-if="loading" size="30" />
					<template v-else>Continue</template>
				</Button>
			</transition>
			<transition name="footer-button">
				<Button color="brand" class="withdrawal__button" size="big" v-if="ready && !complete" :disabled="loading">
					<Loader v-if="loading" size="30" />
					<template v-else>Confirm and send</template>
				</Button>
			</transition>
			<transition name="footer-button">
				<div class="withdrawal__success withdrawal-success" v-if="complete">
					<i class="withdrawal-success__icon">
						<Icon name="check" :size="2" />
					</i>
					<span class="withdrawal-success__text">Done!</span>
				</div>
			</transition>
		</form>
	</ModalLayout>
</template>
<script lang="ts" setup>
import "./WithdrawalView.scss";
import Button from "@/components/Button/Button.vue";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import ModalLayout from "@/layouts/ModalLayout/ModalLayout.vue";
import {computed, ref, watch} from "vue";
import Icon from "@/components/Icon/Icon.vue";
import TelegramWebApp from "@/telegram/TelegramWebApp";
import Loader from "@/components/Loader/Loader.vue";
import {useUserStore} from "@/stores/userStore";
import {storeToRefs} from "pinia";
import {useApiStore} from "@/stores/apiStore";
import {useAlertsStore} from "@/stores/alertsStore";
import ApiError from "@/modules/Api/ApiError";
import {shorty} from "@/modules/helpers";

let userStore = useUserStore();
let alertsStore = useAlertsStore();
let {api} = useApiStore();

let {me} = storeToRefs(userStore);

let ready = ref<boolean>(false);
let loading = ref<boolean>(false);
let complete = ref<boolean>(false);

let amount = ref<string>('0');
let commission = ref<number>(0);
let address = ref<string>('');

let filled = computed<boolean>(() => {
	return !!(address.value.length && amount.value.length && +amount.value > 0);
});

let scanAddress = () => {

	TelegramWebApp.app!.showScanQrPopup({ text: 'Scan QR' }, (data) => {

		if(data){
			address.value = data;

			TelegramWebApp.app!.closeScanQrPopup();
		}

	});

}

let pasteAddress = async () => {

	address.value = await navigator.clipboard.readText();

}

let loadCommission = async () => {

	try {
		commission.value = await api.calculateWithdrawalCommission(+amount.value);
	}catch (e){
		commission.value = 0;
	}

}

let onBack = computed<boolean | Function>(() => {

	if(loading.value){
		return false;
	}

	if(!ready.value){
		return true;
	}

	if(complete.value){
		return true;
	}

	return () => {
		ready.value = false;
	};

});

let onSubmit = async () => {

	if(!ready.value){

		if(!filled.value){
			return;
		}

		loading.value = true;

		if(!await api.validateWithdrawalAddress(address.value)){
			alertsStore.pushError('Address is incorrect');
			loading.value = false;
		}

		ready.value = true;
		loading.value = false;

		ready.value = filled.value;


	}else{

		loading.value = true;

		try{

			await api.withdrawal(+amount.value, address.value);

			complete.value = true;
			loading.value = false;

		}catch(e){

			if(e instanceof ApiError){
				alertsStore.pushError(e.message);
				loading.value = false;

				return;
			}

			throw e;

		}

	}


}

watch(amount, async () => {
	await loadCommission();
});

</script>